<div class="flex flex-col gap-5 m-4 mb-0">
  <sm-form-builder [formObject]="formObject"></sm-form-builder>
</div>
